import React, { Component } from 'react';
import withNotify from '../../common/withNotify';

class SetQuantity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qty: 0,
      newQty: 0
    };
  }

  _onPlusSets = () => {
    const { qty, newQty } = this.state;
    this.setState(() => ({
      qty: qty + 1,
      newQty: newQty + 1
    }));
  }

  _onMinusSets = () => {
    const {
      isPastRec = false, selectedSetName, masterSelectedSetsQty = {}, notify
    } = this.props;
    const { qty, newQty } = this.state;
    if (isPastRec) {
      if (masterSelectedSetsQty[selectedSetName]
        && masterSelectedSetsQty[selectedSetName] === qty) {
        notify({
          type: 'warning',
          message: 'Sets cannot be removed on or after the case date. Please contact your office for assistance.',
          time: 10
        });
        return false;
      }
    }
    if (qty === 0) {
      this.setState({
        qty: 0,
      });
    } else {
      this.setState(() => ({
        qty: qty - 1,
        newQty: newQty - 1
      }));
    }
  }

  _onSubmit = () => {
    const { onSaveSets } = this.props;
    const { qty, newQty } = this.state;
    setTimeout(() => {
      if (qty === 0) {
        this.setState({
          qty: 1,
          newQty: 1
        });
        onSaveSets(qty, newQty);
      } else {
        onSaveSets(qty, newQty);
      }
    }, 300);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const qty = nextProps.qty === 0 ? 1 : nextProps.qty;
    if (nextProps.qty !== this.props.qty) {
      this.setState({
        qty,
        newQty: nextProps.qty === 0 ? 1 : 0
      });
    }
  }

  render() {
    const { qty } = this.state;
    return (
      <div
        className="modal fade theme-modal qty-modal" id="setQtyModal"
        tabIndex="-1"
        aria-labelledby="setQtyModalLabel" aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="setQtyModalLabel">Set Quantity</h5>
              <div className="input-group">
                <button
                  className="btn btn-theme-alt"
                  type="button"
                  onClick={this._onMinusSets}
                >
                  <i className="fas fa-minus" />
                </button>
                <input
                  type="text" className="form-control sets-qty"
                  placeholder="Quantity"
                  min="1"
                  value={qty} readOnly
                />
                <button className="btn btn-theme-alt" type="button" onClick={this._onPlusSets}><i className="fas fa-plus" />
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link btn-left w-100"
                    data-bs-dismiss="modal"
                  >Back
                  </button>
                </div>
                <div className="col-6">
                  <button type="button" className="btn btn-link w-100" onClick={this._onSubmit} data-bs-dismiss="modal">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withNotify(SetQuantity);
